import React, { createContext, useContext, useState, useEffect } from 'react'
import { API_URL } from '../constants'
import { useTranslation } from 'react-i18next'
import { useCart } from './CartContext'
import { languageUtil } from './languageUtils'

// Define the context
const CurrencyContext = createContext()

// Provider component
export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState('GBP')
    const [currencySymbol, setCurrencySymbol] = useState('$')
    const [currencyRate, setCurrencyRate] = useState(1)
    const { language } = languageUtil()
    const { t } = useTranslation()

    useEffect(() => {
        // Check if cart token exists
        const cartToken = localStorage.getItem('cartToken')

        if (!cartToken) {
            // No cart token - reset to GBP defaults
            localStorage.setItem('currency', 'GBP')
            localStorage.setItem('currencySymbol', '£')
            localStorage.setItem('currencyRate', '1')

            setCurrency('GBP')
            setCurrencySymbol('£')
            setCurrencyRate(1)
        } else {
            // Cart token exists - load saved currency
            const savedCurrency = localStorage.getItem('currency') || 'GBP'
            const savedSymbol = localStorage.getItem('currencySymbol') || '£'
            const savedRate = parseFloat(localStorage.getItem('currencyRate') || '1')

            setCurrency(savedCurrency)
            setCurrencySymbol(savedSymbol)
            setCurrencyRate(savedRate)
        }
    }, [])

    const updateCurrency = async (code, symbol, rate) => {
        setCurrency(code)
        setCurrencySymbol(symbol)
        setCurrencyRate(rate)

        const token = localStorage.getItem('cartToken')
        const response = await fetch(`${API_URL}/cart/${token}/currency`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': language,
            },
            body: JSON.stringify({ code }),
        })

        if (!response.ok) throw new Error(t('cart.error.update_currency'))

        localStorage.setItem('currency', code)
        localStorage.setItem('currencySymbol', symbol)
        localStorage.setItem('currencyRate', rate.toString())
    }

    return (
        <CurrencyContext.Provider
            value={{ currency, currencySymbol, currencyRate, updateCurrency }}
        >
            {children}
        </CurrencyContext.Provider>
    )
}

// Custom hook for easy use
export const useCurrency = () => useContext(CurrencyContext)
